import CopyButton, { CopyButtonRow } from './CopyButton';
import { formatCortiSections } from '../utils/noteFormatter';

export default function CortiNoteDisplay({ sections, onSectionChange, patient, datetime }) {
  if (!sections?.length) {
    return (
      <div className="rounded-xl border border-gray-200 bg-gray-50 p-6 text-center text-gray-500">
        No Corti sections available. Please use the OpenAI tab.
      </div>
    );
  }

  const copyText = formatCortiSections(sections, patient, datetime);

  return (
    <div className="space-y-4">
      <CopyButtonRow>
        <CopyButton text={copyText} label="Copy Note" />
      </CopyButtonRow>

      {sections.map((section, index) => (
        <div key={`${section.title}-${index}`} className="overflow-hidden rounded-xl border border-gray-200">
          <div className="flex items-center justify-between gap-2 bg-primary px-4 py-2">
            <span className="font-semibold text-white">{section.title}</span>
            <CopyButton
              text={`${section.title}\n${section.content || '—'}`}
              label="Copy"
              className="!min-h-[28px] !border-white/40 !bg-white/10 !px-2 !py-0.5 !text-xs !text-white hover:!bg-white/20"
            />
          </div>
          <textarea
            value={section.content}
            onChange={(e) => onSectionChange(index, e.target.value)}
            rows={4}
            className="w-full resize-y border-0 p-4 text-sm focus:outline-none focus:ring-2 focus:ring-primary/30"
            aria-label={section.title}
          />
        </div>
      ))}
    </div>
  );
}
